export const buildSelectorFromEstadosResponse = response => (
  response.map(data => ({
    id: data,
    value: data,
  }))
);
